import { jsx as _jsx } from "react/jsx-runtime";
import { Edit } from '@mui/icons-material';
import { getLessonMutationOptions, useUpdateLessonMutation, } from 'api';
import { ConfirmationDialog, LoadingWrapper, Textarea, } from 'components/custom';
import React from 'react';
import { useTranslation } from 'react-i18next';
const NotesDialog = ({ activeLesson, close, }) => {
    const { t } = useTranslation('lesson', {
        keyPrefix: 'cmp.Notes.lessonNotes',
    });
    const [notesText, setNotesText] = React.useState('');
    const [updateLesson, statusUpdateLesson] = useUpdateLessonMutation();
    React.useEffect(() => {
        setNotesText(activeLesson?.notes ?? '');
    }, [activeLesson]);
    const handleSaveLessonNotes = () => {
        void updateLesson(getLessonMutationOptions({
            id: activeLesson?.id ?? '',
            notes: notesText,
        })).then(close);
    };
    return (_jsx(ConfirmationDialog, { open: !!activeLesson, onClose: close, titleProps: {
            Icon: Edit,
            text: `${t('shortLabel')} ${activeLesson?.formatedDateTimePeriod ?? ''}`,
        }, cancelButtonProps: {
            onClick: close,
        }, confirmButtonProps: {
            disabled: statusUpdateLesson.loading,
            onClick: handleSaveLessonNotes,
        }, fullWidth: true, children: _jsx(LoadingWrapper, { mutation: statusUpdateLesson, children: _jsx(Textarea, { minRows: 5, onChange: (e) => {
                    setNotesText(e.currentTarget.value);
                }, value: notesText }) }) }));
};
export default NotesDialog;
